import { useEffect } from 'react';
import { isStaging } from '@/lib/env';

/** Rendered height in px: 2px padding top and bottom around a 14px line. */
const STAGING_BANNER_HEIGHT = 18;

/**
 * StagingBanner — renders a fixed amber bar at the top of every page
 * when VITE_APP_ENV=staging. Invisible on production.
 *
 * It reserves its own height, the way InvestorDemoBanner does: the body is
 * pushed down by it and `--staging-banner-height` tells sticky headers where
 * to stop. It used to float over whatever was first on the page — in the
 * Android staging app that was the booking wizard's progress bar, which the
 * banner hid completely.
 */
export function StagingBanner() {
  useEffect(() => {
    if (!isStaging) return;
    const root = document.documentElement;
    root.style.setProperty('--staging-banner-height', `${STAGING_BANNER_HEIGHT}px`);
    document.body.style.paddingTop = `${STAGING_BANNER_HEIGHT}px`;
    return () => {
      root.style.removeProperty('--staging-banner-height');
      document.body.style.paddingTop = '';
    };
  }, []);

  if (!isStaging) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: STAGING_BANNER_HEIGHT,
        boxSizing: 'border-box',
        background: '#F59E0B',
        color: '#000',
        textAlign: 'center',
        padding: '2px 0',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '14px',
        letterSpacing: '0.01em',
      }}
    >
      [!] STAGING ENVIRONMENT - not for real bookings
    </div>
  );
}
